var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDragdrop(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 50,
    viewBox: "0 0 24 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 50,
    rx: 5,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 21.25C9.328 21.25 10 20.578 10 19.75C10 18.922 9.328 18.25 8.5 18.25C7.672 18.25 7 18.922 7 19.75C7 20.578 7.672 21.25 8.5 21.25ZM8.5 23.5C7.672 23.5 7 24.172 7 25C7 25.828 7.672 26.5 8.5 26.5C9.328 26.5 10 25.828 10 25C10 24.172 9.328 23.5 8.5 23.5ZM7 30.25C7 29.422 7.672 28.75 8.5 28.75C9.328 28.75 10 29.422 10 30.25C10 31.078 9.328 31.75 8.5 31.75C7.672 31.75 7 31.078 7 30.25Z",
    fill: "#100F15"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 21.25C16.328 21.25 17 20.578 17 19.75C17 18.922 16.328 18.25 15.5 18.25C14.672 18.25 14 18.922 14 19.75C14 20.578 14.672 21.25 15.5 21.25ZM15.5 23.5C14.672 23.5 14 24.172 14 25C14 25.828 14.672 26.5 15.5 26.5C16.328 26.5 17 25.828 17 25C17 24.172 16.328 23.5 15.5 23.5ZM14 30.25C14 29.422 14.672 28.75 15.5 28.75C16.328 28.75 17 29.422 17 30.25C17 31.078 16.328 31.75 15.5 31.75C14.672 31.75 14 31.078 14 30.25Z",
    fill: "#100F15"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragdrop);
export default __webpack_public_path__ + "static/media/drag&drop.c185d8f4fe06523994b9efdd66d89739.svg";
export { ForwardRef as ReactComponent };